// Astra · los errores del servidor, en el idioma de la página.
//
// 🔴 **Se traduce por el `codigo`, nunca por el texto.** Desde el 04.11.26 cada
// error de `/cuentas`, del envío de Radar y de la baja de correo trae `codigo`,
// y `campos` cuando falta o está mal un dato (`RESPUESTA_ERRORES_TRADUCIDOS_WEB.md`
// en temp; las tablas, en `CUENTAS_WEB_INSTRUCCIONES.md` §2 y
// `CANAL_ABIERTO_WEB_INSTRUCCIONES.md` §4-ter del portal).
//
// Lo decidió Pablo: son validación, información fija, y mandan material
// personas de muchos países.
//
// 🔴 **En español manda el texto del servidor**, que es el original: no cambia
// ni una letra de lo que se veía, salvo cuando faltan campos (ver abajo). Las
// claves en español existen igual, como fuente de las traducciones.
//
// ⚠️ **Un código que no conocemos pinta el `error` del servidor en español.**
// Así un código nuevo nunca deja a nadie sin mensaje; se añade aquí, en
// `src/locales/*/errores.json`, cuando aparezca.
import { i18n } from "./index";
import { IDIOMA, IDIOMA_BASE } from "./idioma";

const { t, te } = i18n.global;

/** El nombre de un campo del cuerpo de la petición, para leerlo: `email` → «el correo». */
function nombreDelCampo(campo) {
  const clave = `errores.campos.${campo}`;
  return te(clave) ? t(clave) : campo;
}

/** «el correo, el título y el sello», en el idioma de la página. */
export function listaDeCampos(campos = []) {
  const nombres = campos.map(nombreDelCampo);
  if (nombres.length < 2) return nombres[0] || "";
  return t("errores.lista", { primeros: nombres.slice(0, -1).join(", "), ultimo: nombres[nombres.length - 1] });
}

/**
 * El mensaje para quien está delante.
 *
 * @param {object} datos   el cuerpo de la respuesta: `{ codigo, campos, error }`
 * @param {number} estado  el estado HTTP, para el respaldo «Error 500»
 */
export function mensajeDeError(datos, estado) {
  const codigo = datos?.codigo;
  const campos = Array.isArray(datos?.campos) ? datos.campos : [];

  // ⚠️ La excepción a «en español, el texto del servidor»: el suyo nombra los
  // campos como el cuerpo de la petición («Faltan campos obligatorios: title,
  // rightsConfirmed»), y eso no lo entiende nadie. Con `campos`, el nuestro.
  if (codigo === "faltan-campos" && campos.length) {
    return t("errores.codigos.faltan-campos-con", { campos: listaDeCampos(campos) });
  }

  if (IDIOMA === IDIOMA_BASE && datos?.error) return datos.error;
  if (codigo && te(`errores.codigos.${codigo}`)) return t(`errores.codigos.${codigo}`);

  return datos?.error || t("errores.http", { estado });
}
